import React from 'react';
import Container from '../components/layout/Container';
import Button from '../components/common/Button';
import { useLanguage } from '../contexts/LanguageContext';
import './News.css';

const News = () => {
    const { t } = useLanguage();

    const newsItems = [
        {
            id: 1,
            title: 'New Academic Year Registration Open',
            date: 'June 1, 2026',
            category: 'Admissions',
            icon: 'school',
            excerpt: 'Da Vinci Institute is pleased to announce that registrations for the 2026-2027 academic year are now open for all departments.'
        },
        {
            id: 2,
            title: 'Graduation Ceremony 2025',
            date: 'May 15, 2025',
            category: 'Events',
            icon: 'celebration',
            excerpt: 'Celebrate the achievement of our latest graduates who successfully completed their 5-year specialized diplomas.'
        },
        {
            id: 3,
            title: 'Computing Competition Winner',
            date: 'April 20, 2025',
            category: 'Achievement',
            icon: 'emoji_events',
            excerpt: 'Our Computer Science students took first place in the regional software development competition.'
        }
    ];

    return (
        <div className="news-page">
            <header className="page-header">
                <Container>
                    <span className="section-subtitle">
                        <span className="material-icons" style={{ fontSize: '14px' }}>newspaper</span>
                        LATEST UPDATES
                    </span>
                    <h1>
                        {t('nav.news')} & <span className="text-primary">Events</span>
                    </h1>
                    <p className="text-muted mt-4" style={{ maxWidth: '600px', margin: '0 auto' }}>
                        Stay updated with the latest happenings and academic achievements at Da Vinci Institute.
                    </p>
                </Container>
            </header>

            <section className="section">
                <Container>
                    <div className="news-grid">
                        {newsItems.map((item, index) => (
                            <div key={item.id} className={`news-card reveal reveal--up delay-${(index + 1) * 100}`}>
                                <div className="news-card__header">
                                    <span className="news-card__category">{item.category}</span>
                                    <span className="news-card__date">{item.date}</span>
                                </div>
                                <div className="news-card__icon-wrapper">
                                    <span className="material-icons news-card__icon">{item.icon}</span>
                                </div>
                                <h3 className="news-card__title">{item.title}</h3>
                                <p className="news-card__excerpt">{item.excerpt}</p>
                                <Button variant="tertiary" className="news-card__link">
                                    {t('common.readMore')}
                                    <span className="material-icons" style={{ fontSize: '16px', marginLeft: '4px' }}>arrow_forward</span>
                                </Button>
                            </div>
                        ))}
                    </div>
                </Container>
            </section>
        </div>
    );
};

export default News;
